import angular from 'angular';
import moment from 'moment';

module.exports = angular.module('common.values.timezone', [])
.factory('timezone', function() {
  return moment.tz.guess();
}).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/values/timezone.js
 **/